import React, { useState } from 'react';
import { withApollo } from 'react-apollo';
import { array, number, func, object, bool, string } from 'prop-types';
import { Table, Switch } from 'antd';
import { get, filter, toString, head, includes, toNumber } from 'lodash';
import moment from 'moment';
import { Text, TableCount, TableContainer, Icon, Drawer } from '../../common';
import ModalDelete from './ModalDelete';
import { storesKind } from '../../../utils/misc';
import NotificationForm from './NotificationForm';
import updateShopperNotification from '../../graphql/updateShopperNotification';

export const SwitchStatus = ({ item, value, client }) => {
    const [loading, setLoading] = useState(false);

    return <Switch
        key={get(item, 'id_notification')}
        loading={loading}
        checked={value === 1}
        onChange={() => {
            setLoading(true);
            client.mutate({
                mutation: updateShopperNotification,
                variables: { input: {
                    idNotification: get(item, 'id_notification'),
                    status: value === 1 ? 0 : 1
                } },
                refetchQueries: ['getShopperNotifications']
            }).then(() => setLoading(false));
        }}
    />;
};

SwitchStatus.propTypes = {
    item: object,
    value: number,
    client: object
};

const getColumns = (setVisibleModalDelete, setDrawerOpened, client, setIsCreate) => {
    const getDate = (item) =>
        moment(item).isValid() ? moment(item).format('DD-MM-YYYY') : '-';

    return [
        {
            title: 'Nombre',
            dataIndex: 'user_creation',
            className: 'bo-table-header',
            render: (item) => <Text text={item} />
        },
        {
            title: 'Nombre Notificación',
            dataIndex: 'name',
            className: 'bo-table-header',
            render: (item) => <Text text={item} />
        },
        {
            title: 'Tienda',
            dataIndex: 'store_kind',
            className: 'bo-table-header',
            render: (item) => {
                const storeKind = head(filter(storesKind, { id: toString(item) }));
                return <Text text={get(storeKind, 'name', '-')} />;
            }
        },
        {
            title: 'Fecha creación',
            dataIndex: 'creation_date',
            className: 'bo-table-header',
            render: (item) => <Text text={getDate(item)} />
        },
        {
            title: 'Fecha actualización',
            dataIndex: 'update_date',
            className: 'bo-table-header',
            render: (item) => <Text text={getDate(item)} />
        },
        {
            title: 'Activo/Inactivo',
            dataIndex: 'status',
            className: 'bo-table-header',
            render: (value, item) => <SwitchStatus item={item} value={value} client={client} />
        },
        {
            title: 'Editar',
            className: 'bo-table-heade align-center',
            width: 70,
            render: () =>
                <Icon name='edit' size={11} onClick={() => {
                    setIsCreate(false);
                    setDrawerOpened(true);
                }} pointer />
        },
        {
            title: 'Eliminar',
            className: 'bo-table-header align-center',
            width: 70,
            render: () =>
                <Icon name='trash' color='#A4C735' size={11} left={10} onClick={() => setVisibleModalDelete(true)} pointer />
        }
    ];
};

const ShopperNotificationsTable = ({ data, count, setDrawerOpened, drawerOpened, sessionSalesChannel, email, client, isCreate, setIsCreate }) => {
    const [notification, setNotification] = useState({});
    const [visibleModalDelete, setVisibleModalDelete] = useState(false);
    const toggleModalDelete = () => setVisibleModalDelete(!visibleModalDelete);
    const toggleDrawer = () => setDrawerOpened(!drawerOpened);
    const salesChannelIds = JSON.parse(get(notification, 'saleschannels', '[]'));
    const initSalesChannels = filter(sessionSalesChannel, (store) => includes(salesChannelIds, toNumber(get(store, 'value'))));

    return <TableContainer style={{ overflow: 'hidden', overflowY: 'auto' }}>
        {() => (
            <>
                <TableCount count={count} />
                <Table
                    className='bo-table order-table'
                    size='small'
                    columns={getColumns(setVisibleModalDelete, setDrawerOpened, client, setIsCreate)}
                    dataSource={data}
                    pagination={false}
                    onRow={(record, _rowIndex) => ({ onClick: () => setNotification(record) })}
                />
                <ModalDelete
                    notification={notification}
                    visible={visibleModalDelete}
                    toggleModal={toggleModalDelete}
                />
                <Drawer
                    values={['25%', '25%', '100%']}
                    title={`${isCreate ? 'Crear' : 'Editar'} notificación`}
                    visible={drawerOpened}
                    onClose={() => setDrawerOpened(false)}
                    minWidth='311px'
                    bodyStyle={{ paddingRight: 8 }}
                >
                    <NotificationForm sessionSalesChannel={sessionSalesChannel} initSalesChannels={!isCreate ? initSalesChannels : []} toggle={toggleDrawer} notification={!isCreate && notification} email={email} isCreate={isCreate} />
                </Drawer>
            </>
        )}
    </TableContainer>;
};

ShopperNotificationsTable.propTypes = {
    data: array,
    count: number,
    setDrawerOpened: func,
    drawerOpened: bool,
    sessionSalesChannel: array,
    email: string,
    isCreate: bool,
    setIsCreate: func,
    client: object
};

ShopperNotificationsTable.defaultProps = {
    count: 10
};

export default withApollo(ShopperNotificationsTable);
